import {
  Award, BadgeCheck, BookOpen, BrainCircuit, Briefcase, Building2, Calendar, Clock, Code2,
  Globe, GraduationCap, HeartHandshake, Laptop, LineChart, MessagesSquare, MonitorPlay,
  Rocket, ShieldCheck, Sparkles, Star, Target, Trophy, Users, Video,
} from "lucide-react";

/**
 * The icons a login-page highlight may use, by the key the server stores.
 *
 * ⚠️ The keys must match `ICONS` in vc_be/utils/loginPageContent.js — the
 * server refuses any other. `__tests__/components/Auth/loginPageIcons.test.js`
 * pins the list.
 */
export const LOGIN_PAGE_ICONS = {
  "monitor-play": { icon: MonitorPlay, label: "Live class" },
  "brain-circuit": { icon: BrainCircuit, label: "AI" },
  "line-chart": { icon: LineChart, label: "Progress" },
  "badge-check": { icon: BadgeCheck, label: "Verified" },
  "graduation-cap": { icon: GraduationCap, label: "Graduation" },
  "book-open": { icon: BookOpen, label: "Book" },
  users: { icon: Users, label: "People" },
  trophy: { icon: Trophy, label: "Trophy" },
  award: { icon: Award, label: "Award" },
  briefcase: { icon: Briefcase, label: "Career" },
  laptop: { icon: Laptop, label: "Laptop" },
  sparkles: { icon: Sparkles, label: "Sparkles" },
  "shield-check": { icon: ShieldCheck, label: "Trust" },
  clock: { icon: Clock, label: "Time" },
  globe: { icon: Globe, label: "Online" },
  target: { icon: Target, label: "Goal" },
  rocket: { icon: Rocket, label: "Launch" },
  "heart-handshake": { icon: HeartHandshake, label: "Support" },
  building: { icon: Building2, label: "Campus" },
  star: { icon: Star, label: "Star" },
  video: { icon: Video, label: "Video" },
  messages: { icon: MessagesSquare, label: "Chat" },
  calendar: { icon: Calendar, label: "Calendar" },
  code: { icon: Code2, label: "Code" },
};

export const iconFor = (key) => (LOGIN_PAGE_ICONS[key] || LOGIN_PAGE_ICONS["monitor-play"]).icon;
